import { Component, Inject, OnInit, Optional } from '@angular/core';
import { BalancesService } from '../../services/balances/balances-service.service';
import { TradingService } from '../../services/common/trading-service.service';
import { Account } from '../../models/common/trading-common.model';
import { HttpResponse } from '@angular/common/http';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { getElapsedTimeString } from './../../utils/balances/timer.util';
import { Subscription, interval } from 'rxjs';


@Component({
  selector: 'balances-mini',
  templateUrl: './balances-mini.component.html',
  styleUrls: ['./balances-mini.component.css']
})
export class BalancesMiniComponent implements OnInit {
  accountSub: Subscription;
  account: Account;
  balances: any;
  language: string = '';
  platform: string = '';
  clock: string;
  timerSubscription: Subscription;
  showLastRefreshed = false;
  showSpin = false;
  totalAccountWorthValue: number;
  showTotalAccountWorthValue: boolean = false;
  isLoading: boolean = true;
  showBalances = false;



  constructor(
    private tradingService: TradingService,
    private balancesService: BalancesService,
    @Optional() @Inject('AppSettings') appSettings: any
  ) {
    if (!!appSettings) {
      this.language = appSettings.language;
      this.platform = appSettings.platform;
      if (this.language === 'es') {
         registerLocaleData( es );
      }
  }
  }

  ngOnInit() {
    this.accountSub = this.tradingService.accountSubject$.subscribe((acct: Account) => {
      this.account = acct;
      this.fetchBalances();
    });

    if (this.platform && this.platform === 'professional') {
      this.showTotalAccountWorthValue = true;
  }
  }

  fetchBalances() {
    this.showSpin = true;
    this.balancesService.getBalances(this.account.acctNum)
        .subscribe(
          resp =>  this.handleBalancesResp(resp),
          error => console.log('error - ', error)
        );
  }

  startCounter(): void {
    let counter = interval(1000);
    this.timerSubscription = counter.subscribe(val => {
        this.clock = getElapsedTimeString(val, true);
        this.showLastRefreshed = true;
    });
}

  handleBalancesResp(response: HttpResponse<any>): void {
    this.isLoading = false;
    let data = response.body;
    this.showSpin = false;
    if (data.errorCode === 0) {
        if (data.response) {// check if not null
            this.showBalances = true;
            this.balances = data.response.balances;
            this.clearBalances();
            this.startCounter();
            this.totalAccountWorthValue = this.balances.balancesSummary.totalWorth.value;
        }
    } else {
        this.clearBalances();
        this.showBalances = false;
        console.log('resp error code - ', data);
    }
}

private clearBalances(): void {
  if ( this.timerSubscription ) {
      this.timerSubscription.unsubscribe();
  }

  this.showLastRefreshed = false;
  this.clock = '';
  this.totalAccountWorthValue =  undefined;
}

}
